// src/components/Breadcrumbs.tsx
import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  title: string;
  path?: string;
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
}

const routeLabels: Record<string, string> = {
  '/dashboard': 'Главная',
  '/profile': 'Профиль',
  '/diary/glucose': 'Дневник глюкозы',
  '/diary/nutrition': 'Дневник питания',
  '/diary/weight': 'Дневник веса',
  '/diary/movements': 'Дневник шевелений',
  '/diary/symptoms': 'Дневник симптомов',
  '/diary/abdomen': 'Дневник окружности живота',
  '/diary/visits': 'Дневник посещений',
  '/diary/lab-tests': 'Дневник анализов',
  '/charts': 'Графики',
  '/calendar': 'Календарь',
  '/chat': 'Чат',
  '/doctors': 'Пациенты',
  '/admin': 'Админ-панель',
  '/gamification': 'Геймификация',
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getBreadcrumbItems = () => {
    if (items) {
      return items;
    }

    const paths = location.pathname.split('/').filter(Boolean);
    const breadcrumbItems: BreadcrumbItem[] = [
      { title: 'Главная', path: '/dashboard' },
    ];

    let currentPath = '';
    paths.forEach((path, index) => {
      currentPath += `/${path}`;
      const label = routeLabels[currentPath] || path.charAt(0).toUpperCase() + path.slice(1);
      if (index < paths.length - 1) {
        breadcrumbItems.push({ title: label, path: currentPath });
      } else {
        breadcrumbItems.push({ title: label });
      }
    });

    return breadcrumbItems;
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <Breadcrumb
      style={{ marginBottom: 16 }}
      items={breadcrumbItems.map((item, index) => ({
        title: index === 0 ? (
          <span>
            <HomeOutlined style={{ marginRight: 4 }} />
            {item.title}
          </span>
        ) : (
          item.title
        ),
        ...(item.path && index < breadcrumbItems.length - 1
          ? {
              href: '#',
              onClick: (e: React.MouseEvent) => {
                e.preventDefault();
                navigate(item.path!);
              },
            }
          : {}),
      }))}
    />
  );
};
